// extracted by mini-css-extract-plugin
export default {"search":"sZlDC","search__input":"s3N75","search__button":"pDpJn"};